<template>
  <div class="notif-item">
    <div class="mr-3">
      <img class="avatar mt-2" :src="notifIcon" alt="Icon">
    </div>
    <div class="notif-item__content">
      <div class="clearfix">
        <small v-if="subtitle" class="text-muted">{{subtitle}}</small>
        <small class="text-muted float-right mt-1" :title="dateTitle">{{datetime}}</small>
      </div>
      <a :href="url"
        class="notif-item__content__title"
        @click.prevent="markAsRead()"
        :title="title">{{title}}</a>
      <small v-if="description" class="text-muted">{{description}}</small>
    </div>
  </div>
</template>
<style lang="scss">
.notif-item {
  display: flex;
  // flex-wrap: wrap;
  &__content {
    width: 205px;
    overflow: hidden;
    text-overflow: ellipsis;
    &__title {
      font-size: 0.85rem;
      font-weight: bold;
      white-space: nowrap;
    }
  }
}
</style>
<script>

import { titleCase } from 'change-case';
import dateMixins from '../mixins/date';

export default {
  props: ['data'],
  mixins: [dateMixins],
  data() {
    return {
      icons: {
        pdf: 'static/img/doc_icons/pdf.png',
        message: 'static/img/notif_icons/message.png',
        alert: 'static/img/notif_icons/alert.png',
      },
    };
  },
  computed: {
    title() {
      const { occurence } = this.data;
      let { title } = this.data;
      if (!title) {
        return '-';
      }
      title = title.replace('{occurence}', occurence);
      return title;
    },
    metadata() {
      return this.data.metadata || {};
    },
    type() {
      return this.data.type;
    },
    subtitle() {
      return this.metadata.subtitle || titleCase(this.data.type);
    },
    description() {
      return this.metadata.description;
    },
    datetime() {
      return this.formatTimeOrDate(this.data.updated_at);
    },
    dateTitle() {
      return this.formatDateTime(this.data.updated_at);
    },
    notifIcon() {
      if (this.type === 'REPORT') {
        return this.icons.pdf;
      } else if (this.type === 'MESSAGE') {
        return this.icons.message;
      } else if (this.type === 'ALERT') {
        return this.icons.alert;
      }
      return this.icons.alert;
    },
    url() {
      if (this.type === 'REPORT') {
        return '/report/files';
      } else if (this.type === 'MESSAGE') {
        return '/';
      } else if (this.type === 'ALERT') {
        return '/';
      }
      return '/';
    },
  },
  methods: {
    markAsRead() {
      this.$store.dispatch('notifications/DELETE_NOTIFICATION', this.data.id);
      this.asideToggle();
      this.$router.push(this.url);
    },
    asideToggle() {
      document.body.classList.toggle('aside-menu-hidden');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NotificationItem.vue